<div class="animated fadeInRight">
  <!-- MENU DE TITULOS -->
  <app-lfsa-card-v2 [innTemplateButton]="innTemplateButton" [innTemplate]="enviarTemplateEdit"
                    [modulo]="DAT_TITULOS.modulo" [tituloCard]="DAT_TITULOS.titulo" [titulo]="DAT_TITULOS.titulo">
  </app-lfsa-card-v2>
  <!-- MENU DE TITULOS -->

  <!-- OPCIONES LATERAL IZQUIERDO -->
  <ng-template #innTemplateButton>
    <div class="col-md-6 mb-2">
      <div class="pagetitle">
        <div class="btn-group-justified btn-group" style="float: right;">
          <button (click)="nuevo()" class="btn btn-outline-success">
            <i aria-hidden="true" class="fa fa-plus"></i>
            {{DAT_BTNS.nuevo}}
          </button>
        </div>
      </div>
    </div>
  </ng-template>
  <!-- OPCIONES LATERAL IZQUIERDO -->

  <!-- GRILLA -->
  <ng-template #enviarTemplateEdit>
    <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
    <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" [class]="DAT_AG_GRID.class" [columnDefs]="columnDefs"
                     [floatingFilter]="true" [frameworkComponents]="frameworkComponents" [id]="DAT_AG_GRID.id"
                     [ngStyle]="DAT_AG_GRID.style" [paginationPageSize]="DAT_AG_GRID.paginacion" [pagination]="true"
                     [rowData]="rowData">
      [rowSelection]="'single'"
    </ag-grid-angular>
  </ng-template>
  <!-- GRILLA -->
</div>

<!-- MODAL -->
<app-lfsa-modal [classModal]="'modal-lg'" [idButton]="'abrirModal'" [idClose]="'cerrarModal'" [innTemplate]="abrirModal"
                [titulo]="tituloModal"></app-lfsa-modal>
<ng-template #abrirModal>
  <div class="container-fluid">
    <form [formGroup]="agregarForm" mat-dialog-content>
      <div class="row">
        <div class="row">
          <div *ngIf="!isCreate" class="form-group col-12">
            <app-lfsa-input [control]="this.agregarForm.get('id')" [id]="'id'" [label]="'Id'" formControlName="id"
                            type="number"></app-lfsa-input>
            <small *ngIf="this.agregarForm.get('id')?.hasError('pattern')" class="letrasDanger">*Solo
              números y punto, hasta 4 decimales. Ej: 12.3456</small>
          </div>
          <div class="col-6">
            <div class="mb-2">
              <label for="">Proveedor</label>
              <input (change)="onChangeProveedor($event);" (keydown)="noWhitespace($event)"
                     (keyup)="onChangeProveedor($event);this.agregarForm.controls['proveedor'].value.length > 0 ? onChangeValues() : ''"
                     autocomplete="off" class="form-control"
                     formControlName="proveedor" name="proveedor"
                     type="text">
              <div *ngIf="proveeControl?.hasError('required') && proveeControl.touched" class="text-danger">
                <small>*Este campo es requerido</small>
              </div>
              <div *ngIf="proveedorInvalido" class="text-danger">
                <small>*Este proveedor es inválido</small>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="mb-2">
              <label for="">Desc. Proveedor</label>
              <input autocomplete="off" class="form-control" formControlName="despro" name="despro" readonly
                     type="text">
            </div>
          </div>
          <div class="row">
            <div class="form-group col-2">
              <label>Signo</label>
              <select (change)="onChangeValues()" class="form-control" formControlName="signo" name="signo">
                <option value="">-- Seleccione --</option>
                <option value="+">+</option>
                <option value="-">-</option>
              </select>
            </div>
            <div class="form-group col-3">
              <app-lfsa-input (change)="onChangeValues()" (keyup)="onChangeValues()"
                              [control]="this.agregarForm.get('rangoIni')" [id]="'rangoIni'"
                              [label]="'Rango Inicio'" formControlName="rangoIni"
                              type="number"></app-lfsa-input>
              <small *ngIf="this.agregarForm.get('rangoIni')?.hasError('pattern')" class="letrasDanger">*Solo
                números enteros. Ej: 1234</small>
            </div>
            <div class="form-group col-3">
              <app-lfsa-input (change)="onChangeValues()" (keyup)="onChangeValues()"
                              [control]="this.agregarForm.get('rangoFin')" [id]="'rangoFin'"
                              [label]="'Rango Final'" formControlName="rangoFin"
                              type="number"></app-lfsa-input>
              <small *ngIf="this.agregarForm.get('rangoFin')?.hasError('pattern')" class="letrasDanger">*Solo
                números enteros. Ej: 1234</small>
            </div>
            <div class="form-group col-4">
              <app-lfsa-input [control]="this.agregarForm.get('incremento')" [id]="'incremento'" [label]="'Factor'"
                              formControlName="incremento"
                              type="number"></app-lfsa-input>
              <small *ngIf="this.agregarForm.get('incremento')?.hasError('pattern')" class="letrasDanger">*Solo
                números y punto, hasta 8 decimales. Ej: 12.34567890</small>
            </div>
          </div>
        </div>

        <div *ngIf="validSameRecord" class="mt-3 mb-2 text-danger">
          No esta permitido un registro con mismo signo y rango (inicio a fin) a un registro existente.
        </div>

        <!-- (ejecutarEvento)="getCuentasContables()" -->
        <app-lfsa-botones-formulario (devolverAccion)="acciones( $event )" [formularioValido]="validForm()"
                                     [loading]="loading" [textBoton]="'Guardar'" class="row mt-3">
        </app-lfsa-botones-formulario>
      </div>

    </form>
  </div>
</ng-template>
<!-- END MODAL -->
